import About from "./about";
import Trademark from './trademark';
import Patent from './patent';
import Copyright from './copyright';
import RightsProtection from './rightsprotection';
import Dynamic from './dynamic';
export default [
    {
        name: "Home",
        path: "Home",
        component: () => import("@/view/WebViews/Home"),
        meta: {
            title: "胜博知识产权",
            footer: true,
        }
    },
    {
        name: "About",
        path: "About",
        component: () => import("@/view/WebViews/About"),
        redirect: { name: 'Intro' },
        meta: {
            title: "关于",
        },
        children: [...About]
    },
    {
        name: "Trademark",
        path: "Trademark",
        component: () => import("@/view/WebViews/Trademark"),
        redirect: { name: 'QueryDesign' },
        meta: {
            title: "商标注册",
        },
        children: [...Trademark]
    },
    {
        name: "Patent",
        path: "Patent",
        component: () => import("@/view/WebViews/Patent"),
        redirect: { name: 'RetrievalWriting' },
        meta: {
            title: "专利申请",
        },
        children: [...Patent]
    },
    {
        name: "Copyright",
        path: "Copyright",
        component: () => import("@/view/WebViews/Copyright"),
        redirect: { name: 'WorkRegistration' },
        meta: {
            title: "版权登记",
        },
        children: [...Copyright]
    },
    {
        name: "RightsProtection",
        path: "RightsProtection",
        component: () => import("@/view/WebViews/RightsProtection"),
        redirect: { name: 'InventProtect' },
        meta: {
            title: "知产维权",
        },
        children: [...RightsProtection]
    },
    {
        name: "Dynamic",
        path: "Dynamic",
        component: () => import("@/view/WebViews/Dynamic"),
        redirect: { name: 'allDynamic' },
        meta: {
            title: "动态资讯",
        },
        children: [...Dynamic]
    },
    {
        name: "Connect",
        path: "Connect",
        component: () => import("@/view/WebViews/Connect"),
        meta: {
            title: "联系顾问",
        }
    },
]